<script>
import {mapActions} from 'vuex';
import { useAlert } from 'dashboard/composables';

export default{
    props: {
        appointmentId: {
            type: String,
            required: true,
        },
        status:{
            type: String,
            required: true,
        }
    },
    mounted(){
        this.selectedStatus = this.status;
    },  
    data(){
        return{
            selectedStatus: null,
            statusOptions: ["confirmed", "cancelled", "rescheduled", "requested"],
        }
    },
    methods: {
        ...mapActions('appointments', ['updateAppointmentStatus']),
        async handleUpdate(){
            try{
                await this.updateAppointmentStatus({
                    appointmentId: this.appointmentId,
                    status: this.selectedStatus
                });
                useAlert("Status updated successfully")
                this.$emit('refreshDetails');
            }catch(err){
                console.error(err);
                useAlert(err);
            }finally{
                this.$emit('closeModal');
            }
        }
    },
    emits: ['closeModal', 'refreshDetails'],
}
</script>

<template>
    <div data-testid="update_status_modal" class="fixed inset-0 flex items-center justify-center h-[100vh] w-[100vw] bg-slate-900/50 dark:bg-slate-800/50 z-50">
        <div class="p-6 border-2 rounded-lg bg-white dark:bg-slate-800 shadow-lg max-w-md w-full mx-auto">
            <select
                data-testid="update_status_select"
                class="w-full border rounded-md text-gray-900 dark:text-white dark:bg-slate-700 dark:border-gray-600 focus:ring-2 focus:ring-woot-500 focus:outline-none"
                v-model="selectedStatus"
            >
                <option v-for="option in statusOptions" :value="option" :key="option">
                    {{ option }}
                </option>
            </select>

            <span class="flex gap-2 justify-end">
                <woot-button
                    data-testid="update_status_cancel"
                    variant="smooth"
                    color-scheme="secondary"
                    @click="$emit('closeModal')"
                >Cancel</woot-button>
                <woot-button
                    data-testid="update_status_submit"
                    variant="smooth"
                    color-scheme="primary"
                    @click="handleUpdate"
                >Update Status</woot-button>
            </span>
        </div>
    </div>
</template>